export const AUTH_TOKEN = 'auth-token';
export const ESIGN_REVOKE_TOKEN = 'e-sign-revoke-token';
export const AUTH_TYPE = 'auth-type';
export const USER_DATA = 'user-data';
export const ESIGN_REVOKE_KEY_NAME = 'e-sign-revoke-key-name';
export const DISPUTE_FILTER = 'dispute-filter';
